import { createSelector } from '@ngrx/store';
import { SynclogStateInterface, selectAll } from './synclog.state';
import { getSynclogState } from '../setting.selectors';

export const getAllSynclogs = createSelector(
  getSynclogState,
  (state: SynclogStateInterface) => selectAll(state)
);
